import { DataList, DataListEmbedded, DataListRowEntity, EventColumnCollapsibleToggle } from '@/components/types'

import { useIO } from '@/composables/io'

import { useDataStore } from "@/stores/data"

export function useCollapsibleList(metaId: string): any {

  const { get } = useDataStore()

  const range = (size: number, startAt = 0) => {
    return [...Array(size).keys()].map((i) => i + startAt);
  };

  const { performGetBucket, performPostBucket } = useIO()

  const performAction = (entity: DataListRowEntity) => {
    const bucketId = metaId + '/' + entity.entity + '/' + entity.id
    const bucket: DataListEmbedded | {} = get(bucketId)
    const entityIds: string[] = []

    if ('rows' in bucket) {
      for (const row of bucket.rows) {
        for (const rowEntity of row.entities) {
          if (rowEntity.entity === entity.entity) {
            entityIds.push(rowEntity.id)
          }
        }
      }
    }

    if (entity.entry.configuration.collapsible.action === 'get' && entity.entry.configuration.collapsible.url !== undefined) {
      const urlParameters = entityIds.length > 0 ? '?entityids=' + entityIds.join(',') : ''
      performGetBucket(
        entity.entry.configuration.collapsible.url + urlParameters,
        {},
        metaId,
        () => { }
      )
    }

    if (entity.entry.configuration.collapsible.action === 'post' && entity.entry.configuration.collapsible.url !== undefined) {
      performPostBucket(
        entity.entry.configuration.collapsible.url,
        {},
        {
          id: entity.id,
          name: entity.name,
          type: entity.type,
          entity: entity.entity,
          action: entity.entry.configuration.row?.action ?? '',
          entityIds: entityIds
        },
        metaId,
        () => { }
      )
    }
  }

  const columnBodyCollapsibleOnToggle = (event: EventColumnCollapsibleToggle) => {
    const bucket: DataList | {} = get(metaId)

    if (!('rows' in bucket)) return

    const match = bucket.rows.filter((row) => { return (row.id === event.id) })

    if (match.length === 0) return

    const indexToggleSource = parseInt(event.index, 10)
    const indexToggleTarget = match[0].entities[indexToggleSource].entry.configuration.collapsible?.target ?? -1

    if (indexToggleTarget < 0) return

    const collapsibleSourceStateIsClosed = match[0].entities[indexToggleSource].entry.state.collapsible.state === 'closed'

    const indexToggleRange = range(match[0].entities.length - indexToggleSource - 1, indexToggleSource + 1)

    if (collapsibleSourceStateIsClosed) {
      match[0].entities[indexToggleSource].entry.state.collapsible.state = 'open'
      match[0].entities[indexToggleTarget].entry.state.collapsible.parent = 'open'

      performAction(match[0].entities[indexToggleTarget])

    } else {
      for (const i of indexToggleRange) {
        match[0].entities[i].entry.state.collapsible.state = 'closed'
        match[0].entities[i].entry.state.collapsible.parent = 'closed'
      }
      match[0].entities[indexToggleSource].entry.state.collapsible.state = 'closed'
    }
  }

  return {
    columnBodyCollapsibleOnToggle
  }
}
